import { useDeviceType } from '@cian/ui-kit';
import { IconActionCompareAdd16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackingCompareIconClick } from './tracking';
import { Utility } from '../../components/Utility';
import { selectCompareLink } from '../../selectors/servicesLinks';

export const UtilityCompareContainer: React.FC = () => {
  const compareLink = useSelector(selectCompareLink);
  const deviceType = useDeviceType();
  const handleClick = React.useCallback(trackingCompareIconClick, []);

  if (deviceType === 'phone') {
    return null;
  }

  return (
    <Utility
      data-name="UtilityCompareContainer"
      title="Сравнение объектов"
      icon={IconActionCompareAdd16}
      href={compareLink}
      onClick={handleClick}
    />
  );
};
